export const requestSubmissionFlowSteps = {
  START: 'start',
  ENTER: 'enter',
  BUILDING_TYPE: 'building-type',
  ADDRESS: 'address',
  MAP_SELECT: 'map-select',
  FLOOD_RISK: 'flood-risk',
  EXTRA_INFO: 'extra-info',
  CONFIRM_ADDRESS: 'confirm-address',
  BORROWER_SUBMIT: 'borrower-submit',
  SUBMIT: 'submit',
  REPORT: 'report',
}

export const mapSelectActions = {
  VIEW: 'view-building-parcels',
  CONFIRM_BUILDING: 'confirm-main-building',
  SELECT_BUILDING: 'select-main-building',
  CONFIRM_PARCEL: 'confirm-main-parcel',
  SELECT_PARCEL: 'select-main-parcel',
  SELECT_EXTRA_PARCELS: 'select-extra-parcels',
  CHECK_APARTMENT_FLOOR: 'check-apartment-floor',
  FLOOD_ASSESSMENT: 'flood-assessment',
}
